"use client";

import { usePathname } from "next/navigation";
import MobileNav from "@/components/layout/mobile-nav";
import { useIsMobile } from "@/hooks/useIsMobile";

const HIDDEN_MOBILE_NAV_PATTERNS = [
	"/ai",
	"/plaza/lucky-gift",
	"/plaza/lucky-wheel",
];

export function GlobalMobileNav() {
	const pathname = usePathname();
	const { isMobile, isHydrated } = useIsMobile();

	if (!isHydrated || !isMobile) {
		return null;
	}

	const shouldHide = HIDDEN_MOBILE_NAV_PATTERNS.some((pattern) =>
		pathname.startsWith(pattern),
	);

	if (shouldHide) {
		return null;
	}

	return <MobileNav />;
}
